console.log('init')

import login from './js/_alpine-login.js';
new login('Alpine_LoginForm');

import register from './js/_alpine-register.js';
new register('Alpine_RegisterForm');

import AccountCompletionForm from './js/_alpine-account-completion';
new AccountCompletionForm('AccountCompletionForm');

import DynamicForm from './js/_alpine-dynamic-form.js';
new DynamicForm('MijnGegevens');

import ContactPreferences from './js/_alpine-contact-preferences.js';
new ContactPreferences('ContactPreferences');

import Messages from './js/_alpine-messages.js';
new Messages("Alpine_Messages");

import AttacheSubPlan from './js/_alpine-attache-subplan.js';
new AttacheSubPlan('AttacheSubPlan', '/woonmens/api/attache-subplan');

import DetachSubPlan from './js/_alpine-detach-subplan.js';
new DetachSubPlan('DetachSubPlan', '/woonmens/api/detach-subplan');
import SignaturePad from "signature_pad";

import Survey from './js/_alpine-survey.js';
new Survey('Survey', SignaturePad);

import Files from './js/_alpine-files.js';
new Files('Files');


function addTargetBlankToExternalLinks() {
    console.log('Added external to blank')
    setTimeout(function(){ 
        var aTags = document.getElementsByTagName("a");
        for (var i = 0; i < aTags.length; i++) {
            if (aTags[i].href != "" && !aTags[i].href.includes('/account/')) {
                aTags[i].addEventListener("click", function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.open(this.href, '_blank');
                });
            }
        }
     }, 2000);
   
}

window.addEventListener('load', function() {
    addTargetBlankToExternalLinks();
})


window.dataLayer = window.dataLayer || [];

function hasStijlgenotenCookieConsent(){
    var cookie = JSON.parse( localStorage.getItem( 'stijlgenotenCookieConsent' ) );
    var now = +new Date();

 	if( cookie != null ) {
 		if( now < cookie.expires ){
            window.dataLayer.push({'event': 'consent'});
            console.log('Pushed a "consent" event to Google Tag Manager');
        } 
 		else {
            return false;
         }	
 	}
}

hasStijlgenotenCookieConsent();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */


 window.axios = require('axios');

 window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

